import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import styles from './styles.module.scss';
import { Link, useHistory } from 'react-router-dom';

function HeaderMobile({title,accion}) {
  
    const history = useHistory();
    const handleBack = ()=>{
        if(accion){
            accion()
        }else{
            history.goBack();
        }
        
    }

  return (
    <>
        <div className={styles.containerHeaderMobil}> 
            <div className={styles.buttonIconLeft} onClick={handleBack}>
            <i className="fa fa-arrow-left icon" />
            </div>
            <span className={styles.titleName}>{title}</span>
        </div>
    </> 
  );
}

export {
    HeaderMobile
}





